const solutions = [
  {
    icon: 'ri-calendar-line',
    title: 'Personalized Pregnancy Guidance',
    description: 'Week-by-week pregnancy tracking from week 1 to delivery. Know what\'s happening with your baby and what you need to do at every stage.',
    badge: 'Pregnancy'
  },
  {
    icon: 'ri-hospital-line',
    title: 'Smart Hospital Recommendations',
    description: 'Compare government and private hospitals in Pune based on cost, services, NICU availability, and location all in one place.',
    badge: 'Hospitals'
  },
  {
    icon: 'ri-map-2-line',
    title: 'Step-by-Step Care Journey',
    description: 'A clear roadmap of what to do before, during, and after delivery. No guesswork, no overwhelm just a clear path forward.',
    badge: 'Care Plan'
  },
  {
    icon: 'ri-bar-chart-2-line',
    title: 'Data-Driven Insights',
    description: 'Healthcare decisions backed by real data from government guidelines and hospital records. Make informed choices with confidence.',
    badge: 'Insights'
  }
];

export default function Solution() {
  return (
    <section id="solution" className="py-20 sm:py-28 bg-gradient-to-br from-teal-600 via-teal-700 to-sky-700 relative overflow-hidden">
      {/* Background decoration */}
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-96 h-96 bg-white rounded-full -translate-x-1/2 -translate-y-1/2"></div>
        <div className="absolute bottom-0 right-0 w-80 h-80 bg-white rounded-full translate-x-1/3 translate-y-1/3"></div>
      </div>

      <div className="relative z-10 max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-14">
          <div className="inline-flex items-center gap-2 px-4 py-2 bg-white/15 border border-white/25 rounded-full mb-5">
            <i className="ri-checkbox-circle-line text-teal-200"></i>
            <span className="text-sm font-semibold text-white">The Solution</span>
          </div>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-extrabold text-white mb-5 leading-tight">
            MomsFirstCare Makes It{' '}
            <span className="text-teal-200">Simple</span>
          </h2>
          <p className="text-lg text-white/80 max-w-3xl mx-auto leading-relaxed">
            We've brought everything a new or expecting parent needs into one clear, easy-to-use platform, so you can focus on what matters most.
          </p>
        </div>

        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {solutions.map((solution, index) => (
            <div
              key={index}
              className="bg-white/10 backdrop-blur-sm border border-white/20 rounded-2xl p-6 hover:bg-white/15 hover:-translate-y-1 transition-all group"
            >
              <div className="flex items-start justify-between mb-4">
                <div className="w-12 h-12 flex items-center justify-center bg-white/20 rounded-xl group-hover:bg-white/30 transition-colors">
                  <i className={`${solution.icon} text-2xl text-white`}></i>
                </div>
                <span className="text-xs font-bold text-teal-200 bg-teal-800/40 px-2.5 py-1 rounded-full whitespace-nowrap">
                  {solution.badge}
                </span>
              </div>
              <h3 className="text-base font-bold text-white mb-2 leading-snug">{solution.title}</h3>
              <p className="text-sm text-white/75 leading-relaxed">{solution.description}</p>
            </div>
          ))}
        </div>

        <div className="mt-12 text-center">
          <div className="inline-flex items-center gap-3 bg-white/10 border border-white/20 rounded-2xl px-8 py-5">
            <i className="ri-shield-star-line text-3xl text-teal-200"></i>
            <span className="text-white text-base font-medium">
              Built on <strong className="text-teal-200">Government of India healthcare guidelines</strong> for trusted, accurate care
            </span>
          </div>
        </div>
      </div>
    </section>
  );
}
